import { IMPERSONATION_TOKEN_KEY } from "./constants";

export const clearPersistedImpersonation = () => {
  localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
};
